// extracted by mini-css-extract-plugin
module.exports = {"image":"_1p6jxvtd-oP1LrjDXBzWq2 buttonShadow"};